import { Star } from "lucide-react";

import { TYPE_STYLES } from "../utils/constants";
import { getStatusStyle } from "../utils/helpers";
import { TOKENS as T } from "../styles/styles";

export function StarRating({ rating }) {
  if (!rating) {
    return <span style={notRatedStyle}>Not yet rated</span>;
  }

  return (
    <div style={ratingRowStyle}>
      <Star size={14} fill="#FBBF24" color="#FBBF24" />
      <span style={ratingValueStyle}>{rating}</span>
      <span style={ratingMaxStyle}>/5</span>
    </div>
  );
}

export function MiniAvatar({ initial, color, border = false }) {
  return (
    <div
      style={{
        ...miniAvatarStyle,
        backgroundColor: color,
        boxShadow: border ? `0 0 0 2px ${T.card}` : "none",
      }}
    >
      {initial}
    </div>
  );
}

export function TypeBadge({ type }) {
  const typeStyle = TYPE_STYLES[type] || TYPE_STYLES.anime;
  const Icon = typeStyle.icon;

  return (
    <span
      style={{
        ...badgeStyle,
        background: `${typeStyle.color}18`,
        color: typeStyle.color,
      }}
    >
      <Icon size={10} />
      {typeStyle.label}
    </span>
  );
}

export function StatusBadge({ entry }) {
  const status = getStatusStyle(entry);

  if (!status) return null;

  return (
    <span
      style={{ ...badgeStyle, background: status.bg, color: status.color }}
    >
      {status.label}
    </span>
  );
}

// Firestore stores no artwork, so the poster slot from the Figma card renders
// the media-type glyph on a tinted surface rather than a fabricated image.
export function PosterSlot({ type, width, height, radius }) {
  const typeStyle = TYPE_STYLES[type] || TYPE_STYLES.anime;
  const Icon = typeStyle.icon;

  return (
    <div
      style={{
        width,
        height,
        borderRadius: radius,
        background: `${typeStyle.color}14`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Icon size={Math.round(width / 2.6)} color={typeStyle.color} />
    </div>
  );
}

const badgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  padding: "2px 8px",
  borderRadius: 999,
  fontSize: 10,
  fontWeight: 600,
  whiteSpace: "nowrap",
};

const miniAvatarStyle = {
  width: 28,
  height: 28,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 11,
  fontWeight: 700,
  color: "#fff",
  flexShrink: 0,
  marginLeft: -8,
};

const ratingRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: 4,
};

const ratingValueStyle = {
  fontSize: 14,
  fontWeight: 700,
  color: T.foreground,
};

const ratingMaxStyle = {
  fontSize: 12,
  color: T.mutedForeground,
};

const notRatedStyle = {
  fontSize: 12,
  color: T.mutedForeground,
};
